import axios from 'axios'

const instance = () => {
  return axios.create({
    baseURL: process.env.VUE_APP_EVENT_TRACKING_URL,
    timeout: 15000,
    headers: {
      authorization: `Bearer ${process.env.VUE_APP_EVENT_TRACKING_PAGE_TOKEN}`
    }
  })
}

const eventTrackingApi = {
  postEventTracking: (request) => {
    const { body, config = {} } = request
    return instance().post(`/v1/events`, body, {
      ...config
    })
  }
}

export default eventTrackingApi
